export const WEEK_DAYS_LEXICON = [
  `Понедельник`,
  `Вторник`,
  `Среда`,
  `Четверг`,
  `Пятница`,
  `Суббота`,
  `Воскресенье`
];

export const ANOTHER_DAY_LEXICON = `Другая дата`;

export const SUBMIT_TEXT_LEXICON = `Пожалуйста, подождите…`;
export const SUCCESS_TEXT_LEXICON = `Заказ оформлен!`;
